import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { services } from '../../context';
import { ServicesState } from './servicesTypes';
import { sortServicesByPrice } from '../../services/Appointment/utils';
import { CustomerType } from '../user/userTypes';

const initialState: ServicesState = {
  from: new Date().toISOString(),
  prevEnabled: false,
  availableServices: [],
};

export const getServices = createAsyncThunk(
  'services/getServices',
  async (
    {
      customerType,
      allowedMemberDiscounts,
      zipCode,
      operation,
      stateCode,
    }: {
      customerType: CustomerType;
      allowedMemberDiscounts: boolean;
      zipCode: string;
      operation: string;
      stateCode: string | undefined;
    },
    { rejectWithValue },
  ) => {
    const { result, error } = await services.appointment.getAvailableServices(
      customerType,
      allowedMemberDiscounts,
      zipCode,
      operation,
      stateCode,
    );

    if (error) {
      return rejectWithValue(error);
    }

    if (operation.startsWith('design') && CSS_CONFIG.SERVICES.sortByPrice) {
      result.services.sort(sortServicesByPrice);
    }
    return result.services;
  },
);

const servicesSlice = createSlice({
  name: 'services',
  initialState,
  reducers: {
    clearAvailableServices(state) {
      state.availableServices = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getServices.fulfilled, (state, action) => {
      state.availableServices = action.payload;
    });
  },
});

export const { clearAvailableServices } = servicesSlice.actions;

export default servicesSlice.reducer;
